import React, { useState, useRef, useContext, useEffect } from 'react';
import AuthContext from '../../context/auth-context';
import mod from './ChatAppForms.module.css';

function ChatWithUserForm(props) {
	const sentMessageRef = useRef();
	const authCtx = useContext(AuthContext);
	const [displayedMessages, setDisplayedMessages] = useState(
		props.messageData
	); // Initializează starea cu props.messageData
	const [sameLastUser, setSameLastUser] = useState(
		authCtx.user === props.lastUser
	);
	console.log(props.lastUser, authCtx.user, authCtx.user === props.lastUser);

	useEffect(() => {
		// Actualizează starea dacă props.messageData se schimbă
		setDisplayedMessages(props.messageData);
	}, []);

	async function HandlerSendMessage(e) {
		e.preventDefault();
		const message = sentMessageRef.current.value;
		const fromUser = authCtx.user;
		const toUser = props.username;
		const chatWithUserMessage = {
			message,
			fromUser,
			toUser,
		};
		try {
			const response = await fetch(
				`${process.env.REACT_APP_BACKEND_URL}/api/data/sendMessage`,
				{
					method: 'POST',
					headers: {
						'Content-type': 'application/json',
					},
					body: JSON.stringify(chatWithUserMessage),
				}
			);
			const responseData = await response.json();
			if (!response.ok) {
				throw new Error(responseData.message);
			} else {
				props.chatWithUser(message, fromUser);
				setDisplayedMessages(message);
				setSameLastUser(true);
				sentMessageRef.current.value = '';
			}
		} catch (e) {
			console.log(e.message);
		}
	}

	const HandlerGoBack = () => {
		props.goBackToSelectUser();
	};

	return (
		<form className={mod.chatWithUserContainer}>
			<h1>{props.username}</h1>
			<div className={mod.message}>{displayedMessages}</div>
			<textarea className={mod.textarea} ref={sentMessageRef}></textarea>
			<div className={mod.buttonContainer}>
				{!sameLastUser && (
					<button type='submit' onClick={HandlerSendMessage}>
						Send
					</button>
				)}
				<button type='button' onClick={HandlerGoBack}>
					Go Back
				</button>
			</div>
		</form>
	);
}
export default ChatWithUserForm;
